module.exports = __webpack_public_path__ + "img/conversioned.26ee88e4.svg";